export const userRoles = {
    DEALER_SPOC: "DEALER_SPOC",
    UPTIME_CENTRE_ANALYST: "UPTIME_CENTRE_ANALYST",
    DEALER_SPOC_MANAGER: "DEALER_SPOC_MANAGER",
    UPTIME_CENTRE_EXECUTIVE: "UPTIME_CENTRE_EXECUTIVE",
    DEALER_GENERAL_MANAGER:"DEALER_GENERAL_MANAGER",
    BUSINESS_ADMIN:"BUSINESS_ADMIN",
    FSM:"FSM",
    RSM:"RSM",
    ASM:"ASM",
    SERVICE_HEAD:"SERVICE_HEAD",
    HQ:"HQ",
}
